import HundredBricksAPIError from '../HundredBricksAPIError';
class AntiphishingError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AntiphishingError', ...args);
    }
}
export default AntiphishingError;
